import { useEffect, useState } from 'react';
import TabSwitch from '../../../common/progress-bar/TabSwitch';
import InvestmentConcept from './analysis/InvestmentConcept';
import PipelineData from './analysis/PipelineData';
import ArticleIcon from '@mui/icons-material/Article';
import StorageIcon from '@mui/icons-material/Storage';
import { companyDetailsJsonTemplate } from '../../services/apiDataTemplate';
import { Box, Grid, LinearProgress } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { getAnalysisById } from '../../../services/services';
import secureLocalStorage from 'react-secure-storage';

const FinancialAnalysis = () => {

  //#region variables
  const [reportDetails, setReportDetails] = useState();
  const [selectedTab, setSelectedTab] = useState(0);

  //#region click events
  const handleBackClick = () => {
    window.history.back();
  }

  //#region api get calls
  const fetchReportDetails = async () => {
   const analysisId = secureLocalStorage.getItem("documentId");
   const response = await getAnalysisById(analysisId);
    if (response?.status === 200) {
      console.log("Report Details:", response.data?.extAPIResponse?.analysisResult?.summary);
      console.log("Report Details:",response.data?.extAPIResponse?.analysisResult);
      setReportDetails(response.data);
    } else {
      console.error("Failed to fetch report details", response);
    }
  }
  
  useEffect(() => {
    fetchReportDetails();
  }, []);

  //#region tabs
  const tabs = [
    {
      key: 0,
      icon: <ArticleIcon />,
      label: "Investment Concept",
      component: <InvestmentConcept 
                  aiGeneratedDetails={reportDetails?.extAPIResponse?.analysisResult?.summary}
                  analysisDetails={reportDetails}
                  fetchReportDetails={fetchReportDetails} />
    },
    {
      key: 1,
      icon: <StorageIcon />,
      label: "Pipeline Data",
      component: <PipelineData
                  pipelineData={reportDetails?.extAPIResponse?.analysisResult} 
                  analysisDetails={reportDetails} />
    },
  ]

  //#region return
  return (
    <Box className="padding-40">
      <Grid container spacing={2}>
        <Grid item size={12}>
          <div className='child-row-margin-10 align-items-center'>
            <div className='cursor-pointer' onClick={handleBackClick}>
              <ArrowBackIcon color='primary' sx={{ width: '24px',height: '24px' }} />
            </div>
            <div>
              <div className='header-text'>Document Analyzed</div>
              <span>AI-powered financial document analysis</span>
            </div>
          </div>
        </Grid>
        <Grid item size={12}>
          {
            reportDetails
            ? <TabSwitch
                tabs={tabs}
                selectedTab={selectedTab}
                setSelectedTab={setSelectedTab} />
            : <div className='loading-spinner'>
                <LinearProgress />
              </div>
          }
        </Grid>
      </Grid>
    </Box>
  )
}

export default FinancialAnalysis